const AppLanguages = {
    am: {id:1,code:"am",label:"Հայ"},
    ru: {id:2,code:"ru",label:"Рус"},
    en: {id:3,code:"en",label:"Eng"}
}

export{
    AppLanguages
}